module.exports = __webpack_public_path__ + "assets/ic-huobi.df06140c.svg";